import {useQuery} from '@tanstack/react-query';
import {getBrands, getBrand, VerdocsEndpoint} from '@verdocs/js-sdk';

export const useBrands = (organizationId: string) =>
  useQuery({
    enabled: !!organizationId,
    queryKey: ['brands', organizationId],
    queryFn: () => getBrands(VerdocsEndpoint.getDefault(), organizationId),
  });

export const useBrand = (organizationId: string, brandId: string) =>
  useQuery({
    enabled: !!organizationId && !!brandId,
    queryKey: ['brand', organizationId, brandId],
    queryFn: () => getBrand(VerdocsEndpoint.getDefault(), organizationId, brandId),
  });
